module.exports = "/_next/static/images/know-transfez-send-a58280d31233daa82393bf324e0c714c.svg";